module.exports = __webpack_public_path__ + "media/houseWithSignAndRealtorInFront.fb55a5ad.svg";